import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { useContent } from "@/hooks/useContent";
import { formatDate } from "@/lib/content";

export const BlogCard = ({ post, index }) => {
  const d = formatDate(post.date);
  return (
    <Reveal delay={(index % 3) * 0.08}>
      <Link
        to={`/blog/${post.slug}`}
        data-testid={`blog-card-${post.slug}`}
        className="group block border border-[#232638] hover:border-amber-400/50 bg-[#10121A] transition-colors duration-500"
      >
        <div className="overflow-hidden">
          <img
            src={post.cover}
            alt={post.title}
            loading="lazy"
            className="w-full aspect-[16/9] object-cover group-hover:scale-105 transition-transform duration-700"
          />
        </div>
        <div className="p-6">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-amber-400">
            {d ? `${d.day} ${d.month} ${d.year}` : "Sem data"}
          </p>
          <h3 className="font-display text-lg sm:text-xl font-bold uppercase tracking-tight mt-2 flex items-start justify-between gap-3">
            {post.title}
            <ArrowUpRight size={18} className="shrink-0 mt-1 text-zinc-600 group-hover:text-amber-400 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300" />
          </h3>
          <p className="mt-3 text-sm text-zinc-400 font-light leading-relaxed">{post.excerpt}</p>
        </div>
      </Link>
    </Reveal>
  );
};

const BlogPreview = () => {
  const { data: posts } = useContent("/content/posts/index.json", []);
  return (
    <section id="blog" data-testid="blog-section" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
      <SectionHeading
        chapter="05 // Blog & novidades"
        title="Blog da Clássicos"
        note="Histórias, memórias e conhecimento sobre a cultura das pistas."
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.slice(0, 3).map((p, i) => (
          <BlogCard key={p.slug} post={p} index={i} />
        ))}
      </div>
      <Reveal delay={0.2} className="mt-10">
        <Link
          to="/blog"
          data-testid="blog-view-all-link"
          className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-amber-400 transition-colors"
        >
          Ver todos os posts <ArrowUpRight size={14} />
        </Link>
      </Reveal>
    </section>
  );
};

export default BlogPreview;
